import apiClient from "lib/axios";
import type { LoginCredentials, AuthResponse, User } from "types/auth.types";

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>(
      "/auth/login",
      credentials,
    );
    return data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post("/logout").catch(() => {});
  },

  getMe: async (): Promise<User> => {
    const { data } = await apiClient.get<User>("/me");
    return data;
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>("/token/refresh", {
      refresh_token: refreshToken,
    });
    return data;
  },
};
